import React, { Component } from "react";
import { Redirect } from 'react-router';
import PropTypes from "prop-types";
import Version from "version";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import CircularProgress from '@material-ui/core/CircularProgress';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';

import ArrowBack from "@material-ui/icons/ArrowBack";
// @material-ui/icons
import Mobile from "@material-ui/icons/PhoneIphone";

// core components
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import CardFooter from "components/Card/CardFooter";
import Footer from "components/Footer/Footer";
import Snackbar from "components/Snackbar/Snackbar";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { Offline, Online } from "react-detect-offline";

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import theme from 'theme';

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle";

import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

// dotNetifyp

import dotnetify from 'dotnetify';

//Images
import Logo from "assets/img/Logo.png";
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';

var reactPlugin = new ReactPlugin();

const MySwal = withReactContent(Swal);



export class NewPassword extends Component {
    constructor(props) {
        super(props);
        this.vm = dotnetify.react.connect("NewPassword", this, {
            headers: { ClientVersion: Version.getVersion() }
        });
        // Set up function to dispatch state to the back-end.
        this.dispatchState = state => this.vm.$dispatch(state);

        // we use this to make the card to appear after the page has been rendered
        this.state = {
            cardAnimaton: "cardHidden",
            dialogDisabled: false,
            snackbarOpen: false,
            snackbarMessage: '',
            loading: false,
            redirect: false,
            Username: '',
            NotCustomerDialogOpen: false,
            deliveryMethod: 'sms',
        };
        this.usernameInput = React.createRef();
    }

    componentDidMount() {
        // we add a hidden class to the card and after 700 ms we delete it and the transition appears
        setTimeout(
            function () {
                this.setState({ cardAnimaton: "" });
            }.bind(this),
            700
        );
        document.cookie = "ClientVersion = " + Version.getVersion();
    }
    UNSAFE_componentWillUpdate(nextProps, nextState) {
        if (!this.state.ShowConfirmation && nextState.ShowConfirmation) {
            MySwal.fire({
                title: this.props.t('selfcare:info.singleusecodesent') + ' ' + nextState.Delivery,
                icon: 'success',
                confirmButtonColor: theme.palette.primary.main,
            }).then((result) => {
                this.setState({ redirect: true, toUrl: '/' });
            });
        }
        if (!this.state.ShowError && nextState.ShowError) {
            setTimeout(
                function () {
                    var message = nextState.ShowError;
                    this.setState({ loading: false, dialogDisabled: false });
                    this.setState({ ShowError: false });
                    this.setState({ snackbarOpen: true, snackbarMessage: message });
                    this.dispatchState({ ShowError: false });
                }.bind(this),
                100
            );
        }
        if (!this.state.NotCustomerDialogOpen && nextState.NotCustomerDialogOpen) {
            setTimeout(
                function () {
                    this.setState({ loading: false, dialogDisabled: false });
                }.bind(this),
                100
            );
        }
    }
    componentDidUpdate() {
        if (this.state.UsernameErrorText !== '') {
            setTimeout(
                function () {
                    if (this.usernameInput.current) {
                        this.setState({ loading: false, dialogDisabled: false });
                        this.usernameInput.current.focus();
                    }
                }.bind(this),
                100
            );
        }
    }
    componentWillUnmount() {
        this.vm.$destroy();
    }
    handleChange = (event) => {
        this.setState({ deliveryMethod: event.target.value });
    }
    handleSendPassword = e => {
        e.preventDefault();
        this.setState({ loading: true, dialogDisabled: true });
        this.dispatchState({ Username: this.state.Username, UsernameErrorText: '' });
        this.dispatchState({ SendPassword: this.state.deliveryMethod });
    }
    shake = () => {
        this.setState({ cardAnimaton: "cardShake" });
        setTimeout(
            function () {
                this.setState({ cardAnimaton: "" });
            }.bind(this),
            700
        );
    }

    handleNotCustomerDialogClose = () => {
        this.setState({ NotCustomerDialogOpen: false });
    }
    navigateTo = url => {
        this.setState({
            toUrl: url,
            redirect: true
        });
    }

    render() {
        const { classes } = this.props;
        const { t } = this.props;
        const hideSnackbar = _ => {
            this.setState({ snackbarOpen: false });
        }

        return (<div>
            {this.state.redirect ? (<Redirect to={this.state.toUrl} />) : null}
            <Dialog
                open={this.state.NotCustomerDialogOpen}
                onClose={this.handleNotCustomerDialogClose}
                aria-labelledby="responsive-dialog-title">
                <DialogContent>
                    {t('selfcare:dialog.welcome')}
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleNotCustomerDialogClose} color="rose">
                        {t('selfcare:button.ok')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar open={this.state.snackbarOpen} color="rose" message={this.state.snackbarMessage} place="tc" close={true} closeNotification={hideSnackbar} />
            <div className={classes.content}>
                <div className={classes.container}>
                    <GridContainer justify="center">
                        <GridItem xs={10} sm={6} md={4} lg={3}>
                            <GridContainer justify="center">
                                <form onSubmit={(e) => this.handleSendPassword(e)}>
                                    <Card login className={classes[this.state.cardAnimaton]} style={{ width: '320px' }}>
                                        <CardHeader
                                            className={`${classes.cardHeader} ${classes.textCenter}`}
                                            color="rose"
                                        >
                                            <img src={Logo} width={150} alt="Chilimobil" />
                                            <h4 className={classes.cardTitle}>{t('selfcare:title.newpassword')}</h4>
                                        </CardHeader>


                                        <CardBody>
                                            <Offline>
                                                {t('selfcare:info.offline')}
                                            </Offline>
                                            <Online>
                                                <FormControl fullWidth error={this.state.UsernameErrorText !== ''} className={classes.margin}>
                                                    <InputLabel
                                                        classes={{
                                                            root: classes.cssLabel,
                                                            focused: classes.cssFocused,
                                                        }}
                                                        htmlFor="username"
                                                    >
                                                        {t('selfcare:input.mobilenumber')}
                                                    </InputLabel>
                                                    <Input
                                                        onBlur={() => { window.scrollTo(0, 0); }}
                                                        classes={{
                                                            underline: classes.cssUnderline
                                                        }}
                                                        id="username"
                                                        onChange={(event) => { this.setState({ Username: event.target.value, UsernameErrorText: '' }); }}
                                                        type="tel"
                                                        autoFocus
                                                        disabled={this.state.rememberMe || this.state.dialogDisabled}
                                                        value={this.state.Username}
                                                        color="secondary"
                                                        endAdornment={
                                                            <InputAdornment position="end">
                                                                <Mobile className={classes.inputAdornmentIcon} />
                                                            </InputAdornment>
                                                        }
                                                        inputRef={this.usernameInput}
                                                    />
                                                    <FormHelperText id="Username-error-text">{this.state.UsernameErrorText}</FormHelperText>
                                                    <FormLabel style={{ marginTop: '20px' }} color="secondary" component="legend">{t('selfcare:label.sendpasswordon')}</FormLabel>
                                                    <RadioGroup style={{ marginBottom: '-20px' }} row aria-label={t('selfcare:label.sendpasswordon')} name="deliverymethod" value={this.state.deliveryMethod} onChange={this.handleChange}>
                                                        <FormControlLabel
                                                            value="sms"
                                                            control={<Radio color="primary" />}
                                                            label="SMS"
                                                            labelPlacement="end"
                                                        />
                                                        <FormControlLabel
                                                            value="email"
                                                            control={<Radio color="primary" />}
                                                            label="E-post"
                                                            labelPlacement="end"
                                                        />
                                                    </RadioGroup>
                                                </FormControl>


                                            </Online>
                                        </CardBody>
                                        <CardFooter className={classes.justifyContentCenter}>
                                            <Online>
                                                <div className={classes.wrapper}>
                                                    <Button type="submit" variant="contained" color="rose" size="lg" fullWidth disabled={this.state.dialogDisabled}>
                                                        {t('selfcare:button.singleusepassword')}
                                                    </Button>
                                                    <Button variant="contained" size="lg" fullWidth onClick={() => { this.setState({ UsernameErrorText: '' }); this.navigateTo('/'); }}>
                                                        <ArrowBack />
                                                        {t('selfcare:button.backuc')}
                                                    </Button>
                                                    {this.state.loading && <CircularProgress size={36} className={classes.buttonProgress} />}
                                                </div>
                                            </Online>
                                        </CardFooter>

                                    </Card>
                                </form>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>
                </div>
                <Footer />
            </div>
        </div>
        );
    }
}

NewPassword.propTypes = {
    classes: PropTypes.object.isRequired
};

export default compose(
    withStyles(loginPageStyle),
    withTranslation(),
)(withAITracking(reactPlugin, NewPassword));
